import CertificationPage from 'front-office/pages/certification';
import RegisterCertificationInitializer from 'front-office/pages/register-certification';
import RegisterCertificationPage from 'front-office/pages/register-certification/list';
import RegisterCertificationDetail from 'front-office/pages/register-certification/detail';
import RegisterCertificationEdit from 'front-office/pages/register-certification/edit';
import RegisterCertificationNew from 'front-office/pages/register-certification/new';
import HomePage from 'front-office/pages/home';
import ReleaseModeInitializer from 'front-office/pages/release-mode';
import ReleaseModeList from 'front-office/pages/release-mode/list';
import ReleaseModeDetail from 'front-office/pages/release-mode/detail';
import ReleaseModeEdit from 'front-office/pages/release-mode/edit';
import ReleaseModeNew from 'front-office/pages/release-mode/new';
import { Outlet } from 'react-router-dom';
import TypeDocInitializer from 'front-office/pages/type-doc';
import PrintReceiptPosInitializer from 'front-office/pages/print-receipt-pos';
import PrintReceiptPosPage from 'front-office/pages/print-receipt-pos/list';
import TypeDocList from 'front-office/pages/type-doc/list';
import TypeDocDetail from 'front-office/pages/type-doc/detail';
import TypeDocEdit from 'front-office/pages/type-doc/edit';
import TypeDocNew from 'front-office/pages/type-doc/new';
import CashManagementInitializer from 'front-office/pages/cash-management';
import CashManagementHome from 'front-office/pages/cash-management/home';
import CashManagementCheckLastMonth from 'front-office/pages/cash-management/check-last-month';
import CashManagementCheckCurrentMonth from 'front-office/pages/cash-management/check-current-month';
import CashManagementCheckService from 'front-office/pages/cash-management/check-service';
import CashManagementClosingMonthly from 'front-office/pages/cash-management/closing-monthly';
import CashManagementFortnightly from 'front-office/pages/cash-management/fortnightly';

import {
  CashCheckAuthorization,
  CertificationAuthorizations,
  FrontOfficeAuthorizationsList,
  FrontOfficeAuthorizations,
  RegisterCertificationAuthorizations,
  TypeDocAuthorizations,
  ClaimsAuthorizations,
  AuthenticAuthorizations,
  ResidencyPermitAuthorizations,
  StatementsAuthorizations,
  HistoricalAuthorizations,
  ReleaseModeAuthorizations,
  PrintReceiptPosAuthorizations,
  RegistrationIDCardAuthorizations,
  AnnullamentIDCardAuthorizations,
  ReleaseIdCardAuthorizations,
  ReprintCidAuthorizations,
  CashManagementAuthorizations,
  RetrieveIdCardAuthorizations,
  LotsManagementAuthorizations,
  LeverAuthorizations,
  ElectoralAuthorizations,
  ElectoralCardAuthorizations,
  ElectoralCardTableAuthorizations,
} from 'shell/authorizations/front-office';
import { Nocp } from 'shell/utils/nocp';
import ClaimsPage from 'front-office/pages/claims';
import AuthenticPage from 'front-office/pages/authentic';
import ResidencyPermitListPage from 'front-office/pages/residency-permit/list';
import ResidencyPermitEditPage from 'front-office/pages/residency-permit/edit';
import StatementsPage from 'front-office/pages/statements';
import { NotFound } from 'shell/error/components/error-not-found';
import HistoricalPage from 'front-office/pages/historical';
import PageCertificatesInitizializer from 'front-office/pages/released-services';
import CertificatesListPage from 'front-office/pages/released-services/list';
import CertificatesDetailPage from 'front-office/pages/released-services/detail';
import CertificatesVoidPage from 'front-office/pages/released-services/void';
import CertificatesEditPage from 'front-office/pages/released-services/edit';
import RegisterIdCardSearchPersonPage from 'front-office/pages/registration-id-card/search';
import RegisterIdCardPage from 'front-office/pages/registration-id-card/registration';
import ReleaseIdCardSearchPersonPage from 'front-office/pages/release-id-card/search';
import ReleaseIdCardPage from 'front-office/pages/release-id-card/release';
import CancellationIdCardSearchPersonPage from 'front-office/pages/cancellation-id-card/search';
import CancellationIdCardPage from 'front-office/pages/cancellation-id-card/cancellation';
import LeverPage from 'front-office/pages/lever';
import ElectoralPage from 'front-office/pages/electoral';
import ElectoralANPRPage from 'front-office/pages/electoral-anpr';
import LotsManagementList from 'front-office/pages/lots-management/list';
import LotsManagementNew from 'front-office/pages/lots-management/new';
import LotsManagementEdit from 'front-office/pages/lots-management/edit';
import ReprintCidPage from 'front-office/pages/reprint-cid';
import RetrieveIdCardList from 'front-office/pages/retrieve-id-card/list';
import ResearchAmount from 'front-office/pages/amount';
import NewAmount from 'front-office/pages/amount/new';
import EditAmount from 'front-office/pages/amount/edit';
import DetailAmount from 'front-office/pages/amount/detail';
import CardModule from './card-module';
import TableServiceModule from './table-service-module';
import FrontOfficeStorage from 'front-office/pages/storage';
import LotsManagementDetail from 'front-office/pages/lots-management/detail';
import CertificationFormPage from 'front-office/pages/certification-civil-status';
import { ActCertified, ActPrint } from 'shell/authorizations/civil-status';
import ElectoralCardSearchPersonPage from 'front-office/pages/release-electoral-card/search';
import ReleaseElectoralCardComponent from 'front-office/pages/release-electoral-card/release';
import ReleaseIdCardComponent from 'front-office/pages/release-id-card';
import WrapperPersonSearch from 'shell/components/shared/person-search/wrapper-person-search';
import ReprintCidSearchPerson from 'front-office/pages/reprint-cid/search-person';
import ElectoralCardInitializer from 'front-office/pages/electoral-card';
import ElectoralCardPage from 'front-office/pages/electoral-card/list';
import CashCheckHistoricalDetailPage from 'front-office/pages/released-services/detail/historical';
import NestedItemsFrontOfficeIdentityCard from 'shell/components/navbar/front-office/identity-card';
import NestedItemsFrontOfficeServiceTable from 'shell/components/navbar/front-office/service-table';
import AuthorizationVoteSearchPersonPage from 'front-office/pages/authorization-vote/search';
import PrintAuthorizationVotePage from 'front-office/pages/authorization-vote/detail';
import CertificatesRestorePage from 'front-office/pages/released-services/restore';
import CertificationAnscFormPage from 'shell/components/shared/certification-civil-status';

export const frontOfficeRoutes = [
  {
    path: '',
    element: <FrontOfficeStorage />,
    children: [
      {
        path: '/',
        name: '',
        hidden: true,
        authorizations: FrontOfficeAuthorizationsList,
        element: <HomePage />,
      },
      {
        path: '/autentiche',
        name: 'Autentiche',
        authorizations: AuthenticAuthorizations,
        element: <AuthenticPage />,
        children: [],
        order: 2,
      },
      {
        path: '/attestazione',
        name: 'Attestazioni',
        order: 1,
        authorizations: ClaimsAuthorizations,
        element: <ClaimsPage />,
        children: [],
      },
      {
        path: '/autorizzazione-voto',
        name: 'Autorizzazione al voto',
        order: 3,
        authorizations: [FrontOfficeAuthorizations.StampaAutorizzazioneVoto],
        element: <WrapperPersonSearch />,
        children: [
          {
            element: <AuthorizationVoteSearchPersonPage />,
            path: '',
          },
          {
            path: '/stampa',
            element: <PrintAuthorizationVotePage />,
          },
        ],
      },
      {
        path: '*',
        element: <CardModule />,
        authorizations: [
          ...ReleaseIdCardAuthorizations,
          ...ReprintCidAuthorizations,
          ...RegistrationIDCardAuthorizations,
          ...AnnullamentIDCardAuthorizations,
          ...LotsManagementAuthorizations,
          ...RetrieveIdCardAuthorizations,
        ],
        hidden: true,
        nestedItems: NestedItemsFrontOfficeIdentityCard,
        order: 4,
      },
      {
        path: '/certificazione',
        name: 'Certificazione ANPR',
        authorizations: CertificationAuthorizations,
        element: <CertificationPage />,
        children: [],
        order: 5,
      },
      {
        path: '/elettorale',
        name: 'Certificazione Elettorale',
        authorizations: ElectoralAuthorizations,
        element: <ElectoralPage />,
        children: [],
        order: 6,
      },
      {
        path: '/elettorale-anpr',
        name: 'Certificazione Elettorale ANPR',
        authorizations: [...CertificationAuthorizations, FrontOfficeAuthorizations.ElettoraleAnpr],
        element: <ElectoralANPRPage />,
        children: [],
        order: 7,
      },
      {
        path: '/leva',
        name: 'Certificazione Leva',
        authorizations: LeverAuthorizations,
        element: <LeverPage />,
        children: [],
        order: 8,
      },
      {
        path: '/stato-civile/certificazione',
        name: 'Atti cartacei fino al 2025',
        authorizations: ActCertified,
        element: <Outlet />,
        children: [
          {
            path: '',
            element: <CertificationFormPage />,
          },
        ],
        order: 9,
      },
      {
        path: '/stato-civile/certificazione-ansc',
        name: 'Atti per C.F. e in ANSC',
        authorizations: ActPrint,
        element: <Outlet />,
        children: [
          {
            path: '',
            element: <CertificationAnscFormPage isFromFrontOffice />,
          },
        ],
        order: 10,
      },
      {
        path: '/storiche',
        name: 'Certificazione Storica',
        authorizations: HistoricalAuthorizations,
        element: <HistoricalPage />,
        children: [],
        order: 11,
      },
      {
        path: '/dichiarazioni',
        name: 'Dichiarazioni sostitutive',
        authorizations: StatementsAuthorizations,
        element: <StatementsPage />,
        children: [],
        order: 12,
      },
      {
        path: '/gestione-cassa',
        name: 'Gestione Cassa',
        authorizations: CashManagementAuthorizations,
        element: <CashManagementInitializer />,
        order: 13,
        children: [
          {
            path: '',
            element: <CashManagementHome />,
          },
          {
            path: '/mese-corrente',
            element: <CashManagementCheckCurrentMonth />,
            authorizations: [FrontOfficeAuthorizations.UfficioCassa],
          },
          {
            path: '/mese-precedente',
            element: <CashManagementCheckLastMonth />,
            authorizations: [FrontOfficeAuthorizations.UfficioCassa],
          },
          {
            path: '/controllo-servizio',
            element: <CashManagementCheckService />,
            authorizations: [FrontOfficeAuthorizations.UfficioCassa],
          },
          {
            path: '/chiusura-mensile',
            element: <CashManagementClosingMonthly />,
            authorizations: [FrontOfficeAuthorizations.UfficioCassa],
          },
          {
            path: '/stampa-quindicinale',
            element: <CashManagementFortnightly />,
            authorizations: [FrontOfficeAuthorizations.UfficioCassa],
          },
        ],
      },
      {
        path: '/controllo-di-cassa',
        element: <PageCertificatesInitizializer />,
        name: 'Lista servizi rilasciati',
        authorizations: CashCheckAuthorization,
        order: 14,
        children: [
          {
            path: '',
            element: <CertificatesListPage />,
          },
          {
            path: '/annullamento/:idSigla/:idAnno/:progressivo',
            element: <CertificatesVoidPage />,
            authorizations: [FrontOfficeAuthorizations.CertificatoDelete],
          },
          {
            path: '/ripristina/:idSigla/:idAnno/:progressivo',
            element: <CertificatesRestorePage />,
            // authorizations: [FrontOfficeAuthorizations.CertificatoDelete],
          },
          {
            path: '/modifica/:idSigla/:idAnno/:progressivo',
            element: <CertificatesEditPage />,
            authorizations: [FrontOfficeAuthorizations.CertificatoUpdate],
          },
          {
            path: '/dettaglio/:idSigla/:idAnno/:progressivo',
            element: <CertificatesDetailPage />,
            authorizations: [FrontOfficeAuthorizations.CertificatoQuery],
          },
          {
            path: '/dettaglio-storico/:numeroServizio/:idAnno/:tipoRegistro/:matricola',
            element: <CashCheckHistoricalDetailPage />,
            authorizations: [FrontOfficeAuthorizations.CertificatoQuery],
          },
        ],
      },
      {
        path: '/tessere-elettorali',
        element: <ElectoralCardInitializer />,
        name: 'Lista Tessere elettorali',
        order: 15,
        authorizations: ElectoralCardTableAuthorizations,
        children: [
          {
            path: '',
            element: <ElectoralCardPage />,
          },
        ],
      },
      {
        path: '/rilascioPDS',
        name: 'Permesso di soggiorno',
        order: 16,
        authorizations: ResidencyPermitAuthorizations,
        element: <WrapperPersonSearch />,
        children: [
          {
            path: '',
            element: <ResidencyPermitListPage />,
          },
          {
            path: '/modifica',
            element: <ResidencyPermitEditPage />,
            authorizations: [FrontOfficeAuthorizations.DocumentiPDS],
          },
        ],
      },
      {
        path: '/stampa-ricevuta-pos',
        element: <PrintReceiptPosInitializer />,
        name: 'Rilascio ricevuta POS',
        hidden: true,
        authorizations: PrintReceiptPosAuthorizations,
        children: [
          {
            path: '',
            element: <PrintReceiptPosPage />,
          },
        ],
      },
      // TODO vedere menu in colonna sx e eliminare la lista da questo fil
      {
        path: '*',
        element: <TableServiceModule />,
        authorizations: [
          ...TypeDocAuthorizations,
          ...ReleaseModeAuthorizations,
          ...RegisterCertificationAuthorizations,
        ],
        hidden: true,
        nestedItems: NestedItemsFrontOfficeServiceTable,
        order: 18,
      },
      {
        path: '/ricerca-importo',
        name: 'Gestione Importo',
        element: <Outlet />,
        hidden: true,
        children: [
          {
            path: '',
            element: <ResearchAmount />,
            authorizations: [FrontOfficeAuthorizations.RicercaImporto],
          },
          {
            path: '/nuovo',
            element: <NewAmount />,
            authorizations: [FrontOfficeAuthorizations.NuovoImporto],
          },
          {
            path: '/modifica/:codice',
            element: <EditAmount />,
            authorizations: [FrontOfficeAuthorizations.ModificaImporto],
          },
          {
            path: '/dettaglio/:codice',
            element: <DetailAmount />,
            authorizations: [FrontOfficeAuthorizations.RicercaImporto],
          },
        ],
      },
      {
        path: '/ricerca-registro',
        name: 'Ricerca Registro',
        authorizations: RegisterCertificationAuthorizations,
        element: <RegisterCertificationInitializer />,
        hidden: true,
        children: [
          {
            path: '',
            element: <RegisterCertificationPage />,
          },
          {
            path: '/dettaglio/:id/:institution',
            element: <RegisterCertificationDetail />,
            authorizations: [FrontOfficeAuthorizations.CertificazioneRegistroQuery],
          },
          {
            path: '/modifica/:id/:institution',
            element: <RegisterCertificationEdit />,
            authorizations: [FrontOfficeAuthorizations.CertificazioneRegistroUpdate],
          },
          {
            path: '/nuovo',
            element: <RegisterCertificationNew />,
            authorizations: [FrontOfficeAuthorizations.CertificazioneRegistroAdd],
          },
        ],
      },
      {
        path: '/modalita-rilascio',
        element: <ReleaseModeInitializer />,
        name: 'Modalità rilascio',
        authorizations: ReleaseModeAuthorizations,
        hidden: true,
        children: [
          {
            path: '',
            element: <ReleaseModeList />,
          },
          {
            path: '/dettaglio/:id',
            element: <ReleaseModeDetail />,
            authorizations: [FrontOfficeAuthorizations.TipoRilascioQuery],
          },
          {
            path: '/modifica/:id',
            element: <ReleaseModeEdit />,
            authorizations: [FrontOfficeAuthorizations.TipoRilascioUpdate],
          },
          {
            path: '/nuovo',
            element: <ReleaseModeNew />,
            authorizations: [FrontOfficeAuthorizations.TipoRilascioAdd],
          },
        ],
      },
      {
        path: '/tipo-doc',
        name: 'Tipo documento',
        authorizations: TypeDocAuthorizations,
        element: <TypeDocInitializer />,
        hidden: true,
        children: [
          {
            path: '',
            element: <TypeDocList />,
          },
          {
            path: '/dettaglio/:id/:idDoc',
            element: <TypeDocDetail />,
            authorizations: [FrontOfficeAuthorizations.TipoDocQuery],
          },
          {
            path: '/modifica/:id/:idDoc',
            element: <TypeDocEdit />,
            authorizations: [FrontOfficeAuthorizations.TipoDocUpdate],
          },
          {
            path: '/nuovo',
            element: <TypeDocNew />,
            authorizations: [FrontOfficeAuthorizations.TipoDocAdd],
          },
        ],
      },
      {
        path: '/registrazione-carta',
        name: 'Registrazione Carta',
        authorizations: RegistrationIDCardAuthorizations,
        element: <WrapperPersonSearch />,
        hidden: true,
        children: [
          {
            path: '',
            element: <RegisterIdCardSearchPersonPage />,
          },
          {
            path: '/registra',
            element: <RegisterIdCardPage />,
          },
        ],
      },
      {
        path: '/rilascio-carta',
        name: 'Rilascio carta',
        authorizations: ReleaseIdCardAuthorizations,
        element: <ReleaseIdCardComponent />,
        hidden: true,
        children: [
          {
            path: '',
            element: <ReleaseIdCardSearchPersonPage />,
          },
          {
            path: '/rilascio',
            element: <ReleaseIdCardPage />,
          },
        ],
      },
      {
        path: '/tessera-elettorale',
        name: 'Rilascio tessera elettorale',
        authorizations: ElectoralCardAuthorizations,
        element: <WrapperPersonSearch />,
        order: 19,
        children: [
          {
            path: '',
            element: <ElectoralCardSearchPersonPage />,
          },
          {
            path: '/rilascio',
            element: <ReleaseElectoralCardComponent />,
          },
        ],
      },
      {
        path: '/annullamento-carta',
        name: 'Annullamento Carta',
        authorizations: AnnullamentIDCardAuthorizations,
        element: <WrapperPersonSearch />,
        hidden: true,
        children: [
          {
            path: '',
            element: <CancellationIdCardSearchPersonPage />,
          },
          {
            path: '/annulla',
            element: <CancellationIdCardPage />,
          },
        ],
      },
      {
        path: '/ristampa-carta/ricerca-persona',
        name: 'Stampa busta CIE',
        authorizations: ReprintCidAuthorizations,
        element: <WrapperPersonSearch />,
        hidden: true,
        children: [
          {
            path: '',
            element: <ReprintCidSearchPerson />,
          },
          {
            path: '/ristampa',
            element: <ReprintCidPage />,
          },
        ],
      },
      {
        path: '/gestione-lotti',
        name: 'Gestione Lotti',
        element: <Outlet />,
        hidden: true,
        children: [
          {
            path: '',
            element: <LotsManagementList />,
            authorizations: [FrontOfficeAuthorizations.RicercaLotti],
          },
          {
            path: '/nuovo',
            element: <LotsManagementNew />,
            authorizations: [FrontOfficeAuthorizations.ModificaLotti],
          },
          {
            path: '/modifica',
            element: <LotsManagementEdit />,
            authorizations: [FrontOfficeAuthorizations.ModificaLotti],
          },
          {
            path: '/dettaglio',
            element: <LotsManagementDetail />,
            authorizations: [FrontOfficeAuthorizations.RicercaLotti],
          },
        ],
      },
      {
        path: '/recupero-cie',
        name: 'Recupero Cartellini CIE',
        element: <Outlet />,
        hidden: true,
        children: [
          {
            path: '',
            element: <RetrieveIdCardList />,
            authorizations: RetrieveIdCardAuthorizations,
          },
        ],
      },
      {
        element: <NotFound />,
        path: '*',
        hidden: true,
      },
    ],
  },
];

export const frontOfficeBreacrumbs = [
  {
    path: '/',
    name: 'Home',
    element: <Nocp />,
    children: frontOfficeRoutes,
  },
];
